import axios from 'axios'
import { getApiUrl } from '@/config/api'
import auth from '../utils/auth'

// 创建axios实例
const apiClient = axios.create({
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// 请求拦截器 - 动态添加token
apiClient.interceptors.request.use(
  config => {
    const token = auth.getToken()
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  response => response,
  error => {
    console.error('API请求错误:', error)
    // 如果是认证失败，清除token并提示用户
    if (error.response && error.response.status === 401) {
      console.error('认证失败，请重新登录')
      auth.clearAuth()
      // 可以在这里添加跳转登录页的逻辑
      // window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// 配件相关API
export const partsApi = {
  // 获取品牌列表
  getBrandList() {
    return apiClient.get(getApiUrl("/admin-api/apc/listBrand"))
  },

  // 根据品牌ID获取车型列表
  getModelList(brandId) {
    return apiClient.get(getApiUrl(`/admin-api/apc/listModel/${brandId}`))
  },

  // 根据品牌ID和车型ID获取发动机列表
  getEngineList(brandId, modelId) {
    return apiClient.get(getApiUrl(`/admin-api/apc/listEngine/${brandId}/${modelId}`))
  },

  // 根据品牌ID、车型ID、发动机ID获取主分组
  getMainGroup(brandId, modelId, engineId) {
    return apiClient.get(getApiUrl(`/admin-api/apc/listMainGroup/${brandId}/${modelId}/${engineId}`))
  },

  // 根据主分组获取二级分组
  getSubGroup(brandId, modelId, engineId, mainGroupId) {
    return apiClient.get(getApiUrl(`/admin-api/apc/listSubGroup/${brandId}/${modelId}/${engineId}/${mainGroupId}`))
  },

  // 获取产品列表
  getProductList(params) {
    // 确保分页参数存在
    const requestParams = {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      ...params
    }
    return apiClient.get(getApiUrl('/admin-api/apc/listProduct'), { params: requestParams })
  },

  // 根据OE号搜索产品
  searchProductByOe(referenceNumber, type, pageNum = 1, pageSize = 10) {
    return apiClient.get(getApiUrl('/admin-api/apc/listProductByOe'), {
      params: {
        referenceNumber,
        type,
        pageNum,
        pageSize
      }
    })
  },

  // 获取OE列表或大厂号列表
  getOeList(type, apcNo) {
    return apiClient.get(getApiUrl(`/admin-api/apc/listOe/${type}/${apcNo}`))
  },

  // 根据APC号获取发动机列表
  getEngineListByApc(apcNo, pageNum = 1, pageSize = 10) {
    return apiClient.get(getApiUrl('/admin-api/apc/listEngine'), {
      params: {
        apcNo,
        pageNum,
        pageSize
      }
    })
  },

  // 提交询价
  submitInquiry(data) {
    return apiClient.post(getApiUrl('/admin-api/apc/inquiry'), data)
  }
}

export default partsApi
